export default {
    ALREADY_EXISTS: 'A guild with that name already exists.',
    ALREADY_IN_GUILD: 'You are already in a guild.',
    CANNOT_KICK_YOURSELF: 'You cannot kick yourself from the guild.',
    GUILD_FULL: 'This guild is at maximum capacity.',
    MUST_FINISH_TUTORIAL_CREATE: 'You must finish the tutorial before creating a guild.',
    NO_PERMISSION: 'You do not have permission to do that.',
    NO_PERMISSION_RANK: 'You do not have permission to update the rank of that member.',
    NOT_ENOUGH_GOLD: 'You need 30,000 gold in your inventory to create a guild.',
    NOT_ALLOWED_GUESTS_JOIN: 'Guests are not allowed to join guilds.',
    NOT_ALLOWED_GUESTS_CREATE: 'Guests are not allowed to create guilds.'
} as const;
